import React, { useState, useEffect } from "react";
import {
  Card,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Button,
  CardTitle,
} from "reactstrap";
import Center from "react-center";
import * as Icons from "react-feather";
import DataTable from "react-data-table-component";
import Axios from "axios";
import { urlAPI, getUser, getToken } from "utility/Common";
import { useDispatch } from "react-redux";
import { handleActionLogout } from "redux/actions/auth/logoutActions";
import Select from "react-select";
import moment from "moment";
import ModalSelect from "./component/ModalSelect";
import NumberFormat from "react-number-format";

const initSearchState = {
  norm: "",
  nik: "",
  nama: "",
  kodedept: null,
};
const initTable = {
  count: 0,
  rows: [],
};
export default function Index(props) {
  const dispatch = useDispatch();
  const [searchState, setSearchState] = useState(initSearchState);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [viewDetail, setViewDetail] = useState(false);

  const [openSelect, setOpenSelect] = useState(false);
  const [dataSelect, setDataSelect] = useState([]);

  const [tableData, setTableData] = useState(initTable);
  const [tableOps, setTableOps] = useState({
    page: 1,
    limit: 10,
  });

  const [selectorDept, setSelectorDept] = useState([]);
  const [loadingSelectorDept, setLoadingSelectorDept] = useState(false);

  const handlePerRowsChange = (newPerPage, page) => {
    setTableOps({ ...tableOps, limit: newPerPage, page: 1 });
  };
  const handlePageChange = (page) => {
    setTableOps({ ...tableOps, page: page });
  };

  const fetchSelectorDept = () => {
    Axios.get(
      urlAPI +
        "/v1/customerdept/data?params=" +
        JSON.stringify({
          isSelector: true,
        }),
      {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      }
    )
      .then((response) => {
        if (response?.data?.result?.rows?.length !== 0) {
          const selectorTemp = response?.data?.result?.rows
            ?.filter((filter) => filter.kodedept.trim() !== "")
            .map((obj) => ({
              value: obj?.kodedept,
              label:
                obj?.namadept === obj?.namaalias
                  ? obj?.kodedept + " | " + obj?.namadept
                  : obj?.kodedept +
                    " | " +
                    obj?.namadept +
                    " " +
                    obj?.namaalias,
              custno: obj?.custno,
              namadept: obj?.namadept,
              namaalias: obj?.namaalias,
            }));
          setSelectorDept(selectorTemp);
          setLoadingSelectorDept(false);
        } else {
          setLoadingSelectorDept(false);
        }
      })
      .catch((err) => {
        if (err.response?.statusText === "Unauthorized") {
          setLoadingSelectorDept(false);
          dispatch(handleActionLogout());
        } else {
          dispatch({
            type: "FILL_GAGAL",
            gagal: true,
            pesan: err?.response?.data?.message,
          });
          setLoadingSelectorDept(false);
        }
      });
  };

  useEffect(() => {
    fetchSelectorDept();
    setLoadingSelectorDept(true);
  }, []);

  const handleSearch = () => {
    Axios.get(
      urlAPI +
        "/v1/rekammedik/riwayatresep?params=" +
        JSON.stringify({ ...searchState }),
      {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      }
    )
      .then((response) => {
        if (response?.data?.result?.rows?.length > 0) {
          let distinct = [
            ...new Set(
              response?.data?.result?.rows.map((item) => item.NORM.trim())
            ),
          ];
          if (distinct.length > 1) {
            let tempDataSelect = [];
            for (let i = 0; i < distinct.length; i++) {
              let findNama = response?.data?.result?.rows.find(
                (find) => find.NORM === distinct[i]
              );
              tempDataSelect.push({
                NORM: distinct[i],
                NAMAPASIEN: findNama?.NAMAPASIEN,
                ALAMATPASIEN: findNama?.ALAMATPASIEN,
              });
            }
            setDataSelect(tempDataSelect);
            setTableData({
              ...response?.data?.result,
            });
            setOpenSelect(true);
          } else {
            setTableData({
              ...response?.data?.result,
            });
            setViewDetail(true);
          }
          setLoadingSearch(false);
        } else {
          setTableData({ ...initTable, rows: [] });
          setViewDetail(false);
          setLoadingSearch(false);
        }
      })
      .catch((err) => {
        if (err.response?.statusText === "Unauthorized") {
          setLoadingSearch(false);
          dispatch(handleActionLogout());
        } else {
          dispatch({
            type: "FILL_GAGAL",
            gagal: true,
            pesan: err?.response?.data?.message,
          });
          setLoadingSearch(false);
        }
      });
  };

  console.log("tableData", tableData);

  return (
    <>
      <ModalSelect
        open={openSelect}
        data={dataSelect}
        handleClose={() => {
          setDataSelect([]);
          setOpenSelect(false);
        }}
        handleSelect={(event) => {
          let tempTableData = tableData?.rows;
          let filteringData = tempTableData.filter(
            (filter) => filter.NORM.trim() === event.trim()
          );
          filteringData.sort((a, b) => b.TANGGAL - a.TANGGAL);
          setTableData({ count: filteringData.length, rows: filteringData });
          setDataSelect([]);
          setOpenSelect(false);
          setViewDetail(true);
        }}
      />
      <h1>
        <strong>Riwayat Resep</strong>
      </h1>
      <br />
      <Card body>
        <Row>
          <Col lg="4" md="4" sm="12">
            <Center>
              <img
                src="/assets/img/medic-3.svg"
                className="img-responsive"
                style={{ width: "90%" }}
                alt="pasien"
              />
            </Center>
          </Col>
          <Col lg="8" md="8" sm="12">
            <Row>
              <Col lg="6" md="6" sm="12">
                <FormGroup>
                  <Label>NORM</Label>
                  <Input
                    name="norm"
                    id="norm"
                    type="text"
                    value={searchState?.norm}
                    onChange={(e) =>
                      setSearchState({ ...searchState, norm: e.target.value })
                    }
                  />
                </FormGroup>
                <FormGroup>
                  <Label>NIK</Label>
                  <Input
                    name="nik"
                    id="nik"
                    type="text"
                    value={searchState?.nik}
                    onChange={(e) =>
                      setSearchState({ ...searchState, nik: e.target.value })
                    }
                  />
                </FormGroup>
              </Col>
              <Col lg="6" md="6" sm="12">
                <FormGroup>
                  <Label>Nama Pasien</Label>
                  <Input
                    name="namapasien"
                    id="namapasien"
                    type="text"
                    value={searchState?.nama}
                    onChange={(e) =>
                      setSearchState({ ...searchState, nama: e.target.value })
                    }
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Departemen</Label>
                  <Select
                    styles={{
                      color: "black",
                    }}
                    id="departemen"
                    name="departemen"
                    isLoading={loadingSelectorDept}
                    isClearable={true}
                    options={selectorDept}
                    value={selectorDept.find(
                      (find) => find.value === searchState?.kodedept
                    )}
                    onChange={(e) => {
                      setSearchState({
                        ...searchState,
                        kodedept: e?.value ? e.value : null,
                      });
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Button
              className="float-right"
              color="success"
              style={{ width: "150px" }}
              onClick={() => {
                setTableOps({ ...tableOps, page: 1 });
                setLoadingSearch(true);
                handleSearch();
              }}
              disabled={
                loadingSearch ||
                (searchState?.norm.trim() === "" &&
                  searchState?.nik.trim() === "" &&
                  searchState?.nama.trim() === "" &&
                  searchState?.kodedept === null)
              }
            >
              <Icons.Search size={14} />{" "}
              {!loadingSearch ? " Cari" : " Loading..."}
            </Button>
          </Col>
        </Row>
      </Card>
      {viewDetail && (
        <Card body>
          <CardTitle>Data Pasien</CardTitle>
          <Row>
            <Col lg="6" md="6" sm="12">
              <FormGroup>
                <Label>NORM</Label>
                <Input
                  name="norm"
                  id="norm"
                  type="text"
                  value={tableData?.rows[0]?.NORM}
                  disabled={true}
                />
              </FormGroup>
              <FormGroup>
                <Label>NIK</Label>
                <Input
                  name="nik"
                  id="nik"
                  type="text"
                  value={tableData?.rows[0]?.NIK}
                  disabled={true}
                />
              </FormGroup>
            </Col>
            <Col lg="6" md="6" sm="12">
              <FormGroup>
                <Label>Nama Pasien</Label>
                <Input
                  name="namapasien"
                  id="namapasien"
                  type="text"
                  value={tableData?.rows[0]?.NAMAPASIEN}
                  disabled={true}
                />
              </FormGroup>
              <FormGroup>
                <Label>Departemen</Label>
                <Select
                  styles={{
                    color: "black",
                  }}
                  id="departemen"
                  name="departemen"
                  isLoading={loadingSelectorDept}
                  options={selectorDept}
                  value={selectorDept.find(
                    (find) =>
                      find.value === tableData?.rows[0]?.KODEDEPT?.trim()
                  )}
                  isDisabled={true}
                />
              </FormGroup>
            </Col>
          </Row>
          <FormGroup>
            <Label>Alamat</Label>
            <Input
              name="alamat"
              id="alamat"
              type="textarea"
              rows="2"
              value={tableData?.rows[0]?.ALAMATPASIEN}
              disabled={true}
            />
          </FormGroup>
          <hr />
          <CardTitle>Daftar Riwayat Obat</CardTitle>
          <DataTable
            data={tableData?.rows}
            progressPending={loadingSearch}
            columns={[
              {
                name: "NOREG",
                sortable: false,
                width: "130px",
                cell: (row) => row?.NOREG,
              },
              {
                name: "Tanggal",
                sortable: false,
                width: "140px",
                cell: (row) => moment(row?.TANGGALJUAL).format("DD-MM-YYYY"),
              },
              {
                name: "No Resep",
                sortable: false,
                width: "150px",
                cell: (row) => row?.NORESEP,
              },
              {
                name: "Farmasi",
                sortable: false,
                cell: (row) => row?.NAMAFARMASI,
              },
              {
                name: "Obat",
                sortable: false,
                cell: (row) => row?.NAMAOBAT,
              },
              {
                name: "Jumlah",
                sortable: false,
                width: "100px",
                cell: (row) => (
                  <NumberFormat
                    value={Number(row?.JUMLAH)}
                    displayType={"text"}
                    decimalSeparator={","}
                    thousandSeparator={"."}
                    decimalScale={0}
                    fixedDecimalScale={true}
                  />
                ),
              },
            ]}
            noHeader
            pagination
            paginationDefaultPage={tableOps?.page}
            paginationPerPage={tableOps?.limit}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
          />
        </Card>
      )}
    </>
  );
}
